import React from 'react';
import { Box, Typography, Paper, Chip, Divider } from '@mui/material';
import GradeIcon from '@mui/icons-material/Grade';
import ScoreIcon from '@mui/icons-material/Score';
import TextFieldsIcon from '@mui/icons-material/TextFields';

const FeedbackHeader = ({ score, grade, wordCount, promptAlignment, colors }) => {
    // Determine grade color
    const getGradeColor = (grade) => {
        if (!grade) return colors.grey[400];
        if (grade.startsWith('A')) return colors.greenAccent[400];
        if (grade.startsWith('B')) return colors.blueAccent[400];
        if (grade.startsWith('C')) return colors.yellowAccent[400];
        return colors.redAccent[400];
    };

    return (
        <Paper
            elevation={3}
            sx={{
                p: 3,
                backgroundColor: colors.primary[600],
                borderRadius: '12px',
            }}
        >
            {/* Score and Grade Row */}
            {/* <Box
                display="flex"
                flexWrap="wrap"
                gap={3}
                alignItems="center"
                mb={2}
            >
                <Box display="flex" alignItems="center" gap={1}>
                    <ScoreIcon sx={{ color: colors.greenAccent[400] }} />
                    <Typography variant="h4" fontWeight="bold">
                        Score: {score !== undefined ? score : '--'}/100
                    </Typography>
                </Box>

                <Box display="flex" alignItems="center" gap={1}>
                    <GradeIcon sx={{ color: getGradeColor(grade) }} />
                    <Chip
                        label={`Grade: ${grade || '--'}`}
                        sx={{
                            fontSize: '1.2rem',
                            fontWeight: 'bold',
                            backgroundColor: getGradeColor(grade),
                            color: colors.grey[100],
                            px: 1,
                        }}
                    />
                </Box>

                <Box display="flex" alignItems="center" gap={1}>
                    <TextFieldsIcon sx={{ color: colors.grey[300] }} />
                    <Typography variant="h6" color={colors.grey[300]}>
                        Word Count: {wordCount || '--'}
                    </Typography>
                </Box>
            </Box>

            <Divider sx={{ my: 2 }} /> */}

            {/* Prompt Alignment */}
            {promptAlignment && (
                <Box>
                    <Typography variant="h6" fontWeight="bold" mb={1} color={colors.blueAccent[300]}>
                        Prompt Alignment
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                        {promptAlignment}
                    </Typography>
                </Box>
            )}
        </Paper>
    );
};

export default FeedbackHeader;
